import Swiper, {EffectFade} from 'swiper';

import {ConnectedComponent} from '@lib/ConnectedComponent';
import {appSelectors} from '@lib/store/appState';
import {sharedComponent} from '@lib/utils';
import {MediaQuery} from '@services/MediaQuery';
import {WindowService} from '@services/WindowService';

@sharedComponent
export class Nav extends ConnectedComponent {
  swiper: Swiper | null = null;
  links: HTMLAnchorElement[] = [];
  initialSlide = 1;
  mq = MediaQuery.create();
  window = WindowService.create();

  constructor() {
    super();
    this.resize = this.resize.bind(this);
    this.onMouseClick = this.onMouseClick.bind(this);
    this.onMouseEnterLink = this.onMouseEnterLink.bind(this);
    this.onMouseLeaveLink = this.onMouseLeaveLink.bind(this);
  }

  didMount() {
    this.window.onResize.connect(this.resize);

    this.observe(appSelectors.selectIsOpenGlobalNav, (isOpen) => {
      isOpen
        ? this.element?.classList.add('show')
        : this.element?.classList.remove('show');
    });

    const swiperElement = this.element?.querySelector(
      '.swiper',
    ) as HTMLDivElement;

    if (swiperElement) {
      const options = JSON.parse(swiperElement.dataset['swiper'] as string);
      this.swiper = new Swiper(swiperElement, {
        ...options,
        allowTouchMove: false,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        modules: [EffectFade],
      });

      this.resize();
    }

    if (this.element) {
      this.links = [
        ...this.element.querySelectorAll('.m-nav-item_link'),
      ] as HTMLAnchorElement[];

      this.links.map((link) => {
        link.addEventListener('click', this.onMouseClick);
        link.addEventListener('mouseenter', this.onMouseEnterLink);
        link.addEventListener('mouseleave', this.onMouseLeaveLink);
      });
    }
  }

  didUnmount() {
    this.swiper?.destroy();
    this.links.map((link) => {
      link.removeEventListener('click', this.onMouseClick);
      link.removeEventListener('mouseenter', this.onMouseEnterLink);
      link.removeEventListener('mouseleave', this.onMouseLeaveLink);
    });
  }

  onMouseClick(event: MouseEvent) {
    const target = event.currentTarget as HTMLAnchorElement;
    const index = Number(target.dataset['index']);
    this.initialSlide = index;
    this.swiper?.slideTo(this.initialSlide);
  }
  onMouseEnterLink(event: MouseEvent) {
    const target = event.currentTarget as HTMLAnchorElement;
    const index = Number(target.dataset['index']);
    this.swiper?.slideTo(index);
  }

  onMouseLeaveLink() {
    this.swiper?.slideTo(this.initialSlide || 1);
  }

  resize() {
    if (this.mq.isPhone()) {
      const height = window.innerHeight;
      this.element && (this.element.style.height = `${height}px`);
    } else {
      this.element && (this.element.style.height = '');
    }
  }
}
